import React, {useState} from 'react';
import {useQuery} from "react-query";
import {Link, useParams} from 'react-router-dom';
import useApi from '../../hooks/useApi/useApi';
import {IBoard} from '../../ModelContracts';

import './BoardsNav.css';

interface IProps {
	onAddCustomer: Function
}

function BoardsNav({onAddCustomer}: IProps) {
	const { boardId } = useParams();
	const [boards, setBoards] = useState([] as IBoard[]);
	const [searchTerm, setSearchTerm] = useState('');

	const {getBoards, getAvailableOnboardings} = useApi();

	useQuery<IBoard[], Error>('boards', getBoards, {
		onSuccess: (boards: IBoard[]) => {
			setBoards(boards);
		}
	});

	const {data: availableOnboardings, isLoading} =
		useQuery(['available-onboardings'], getAvailableOnboardings);

	const getSearchedBoards = () => {
		const matchesSearch = (value: string) => value.toLowerCase().includes(searchTerm.toLowerCase());

		if (!searchTerm) return boards;
		return boards.filter((b: any) => matchesSearch(b.name));
	}

	const getBoardUrl = (board: IBoard) => {
		return `/boards/${board.id}`;
	}

	const handleOpen = () => {
		onAddCustomer();
	};

	return (
		<nav className="boards-nav bg-base-300" data-theme="dark" aria-label="Customers nav">
			<ul className="menu w-full">
				<li className="menu-title text-center">Customers</li>
				<li>
					<input
						id="search-boards"
						type="text"
						placeholder="Search"
						aria-label="Search"
						className="input input-bordered input-sm w-full mb-2"
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.currentTarget.value)}
					/>
				</li>
				{
					getSearchedBoards().map((b: any) =>
						<li key={b.id}>
							<Link className={boardId === b.id ? 'active' : ''} to={getBoardUrl(b)}>{b.name}</Link>
						</li>
					)
				}
			</ul>
			{
				!isLoading &&
				<div className="create-customer bg-base-300">
					<button
						className="btn btn-ghost btn-sm"
						title={
							`${availableOnboardings?.amountUsed ?? 0} of ` +
							`${availableOnboardings?.amountInPlan ?? 0} available active onboardings used`
						}
						onClick={handleOpen}
						disabled={!availableOnboardings?.moreAvailable}>
						<i className="bi bi-plus-circle-fill"></i>
						Add Customer
					</button>
					{
						!availableOnboardings?.moreAvailable &&
						<p className="text-sm italic px-4">
							<Link to={"/plan"}
								  className="underline">Upgrade plan</Link> or archive
							customer
							to add more
						</p>
					}
				</div>
			}
		</nav>
	)
}

export default BoardsNav;
